"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentUsageModeEnum = void 0;
exports.DocumentUsageModeEnum = {
    Prompt: "prompt",
    Auto: "auto",
};
